import React from 'react';
import { findIndex } from 'lodash';
import PropTypes from 'prop-types';
import { Box, Button, CardContent, Grid, Paper, Typography } from '@availity/element';
import { getSpecificEnv } from '@availity/env-var';

import { AvailityHeaderLogo, Footer, MessageDisplay, NonProdBanner } from '@/components';
import { useAppContext } from '@/context';
import { useFRCallback } from '@/hooks';

const currentEnv = getSpecificEnv();
const shouldShowNonProdBanner = currentEnv !== 'prod';

const NewUserClickToVerify = ({ ...props }) => {
  const { stepToRender, setCurrentStep } = props;
  const { setMessages } = useAppContext();
  const { callbacks = [], confirmationCallbackIndex, confirmationCallbackOptions } = useFRCallback(stepToRender);

  const handleVerify = () => {
    setMessages([]);

    const output = stepToRender;

    // find the index of the 'yes' option in the confirmation callback
    const newCallbacks = [...callbacks];
    const yesOptionIndex = findIndex(
      confirmationCallbackOptions,
      (optionValue) => optionValue?.toLowerCase() === 'yes'
    );

    if (yesOptionIndex) {
      // build new callbacks with the 'yes' option index in the input
      newCallbacks[confirmationCallbackIndex].input = [
        {
          ...newCallbacks[confirmationCallbackIndex].input[0],
          value: yesOptionIndex,
        },
      ];
    }

    Object.assign(output.payload.callbacks, [...newCallbacks]);

    setCurrentStep({ ...output });
  };

  return (
    <Grid
      id="new-user-click-to-verify-page-grid-container"
      container
      display="flex"
      flexDirection="column"
      flexWrap="wrap"
      spacing={0}
      sx={{ minHeight: '100vh', justifyContent: 'center' }}
    >
      {shouldShowNonProdBanner ? (
        <Grid
          id="nonprod-banner-grid-container"
          display="flex"
          mx={2}
          mt={2}
          justifyContent="center"
          sx={{ marginBottom: { xs: 2, md: 0 } }}
        >
          <NonProdBanner />
        </Grid>
      ) : (
        <Box />
      )}
      <AvailityHeaderLogo />
      <Grid id="click-to-verify-page-content-grid" display="flex" flexDirection="column" alignItems="center">
        <Grid direction="column" alignItems="center" justifyContent="center">
          <Paper variant="elevation" elevation={6} sx={{ width: { xs: '350px', sm: '500px', md: '700px' } }}>
            <CardContent>
              <Box mb={3}>
                <Typography variant="h1" mb={2}>
                  Welcome to Availity!
                </Typography>
              </Box>
              <Typography variant="subtitle1" mb={2}>
                By confirming your email address you can easily add an extra layer of security to your account. In the
                future you can use this email to recover lost passwords.
              </Typography>
              <Typography variant="subtitle1" mb={2}>
                Just click the button below to continue creating your Availity Account.
              </Typography>
              <Typography variant="subtitle1" mb={2} sx={{ fontWeight: 'bold' }}>
                TODO: Email Address
              </Typography>
              <MessageDisplay />
              <Box mb={2}>
                <Button color="primary" onClick={() => handleVerify()}>
                  Confirm my email address
                </Button>
              </Box>
              <Box>
                <Typography variant="subtitle1" mb={2} sx={{ fontStyle: 'italic' }}>
                  Sincerely,
                </Typography>
                <Typography variant="subtitle1" sx={{ fontStyle: 'italic' }}>
                  Availity
                </Typography>
              </Box>
            </CardContent>
          </Paper>
        </Grid>
      </Grid>
      <Footer />
    </Grid>
  );
};

NewUserClickToVerify.propTypes = {
  stepToRender: PropTypes.object.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
};

export default NewUserClickToVerify;
